// Bangla (bn-BD) user-guide copy; HR/legal and native-speaker review is required before release.
export const USER_GUIDE_TRANSLATIONS_BN = {
  'getting-started': {
    title: 'শুরু করুন',
    summary: 'পোর্টাল ব্যবহার, ফোনে অ্যাপ ইনস্টল এবং অ্যাকাউন্ট পরিচালনা শিখুন।',
    blocks: [
      {
        text: 'আপনি ইতিমধ্যে সাইন ইন করেছেন—কঠিন কাজটি হয়ে গেছে। প্রথমবার লগ ইন করার সময় পোর্টাল আপনাকে গোপনীয়তা নীতি (PDPA) স্বীকার করতে এবং নিজের পাসওয়ার্ড সেট করতে সাহায্য করেছে। এখন থেকে পোর্টালে কীভাবে কাজ করবেন, এই পৃষ্ঠায় তা দেখানো হয়েছে।',
      },
      {
        heading: 'পোর্টালে কোথায় কী পাবেন',
        items: [
          'মেনু (সাইডবার): ফিচারের তালিকা খুলতে মোবাইলে ওপরের বাঁ দিকে ☰ মেনু আইকনে চাপুন। কম্পিউটারে এটি বাঁ পাশে খোলা থাকে।',
          'নোটিফিকেশন: ওপরের ডান দিকে 🔔 ঘণ্টায় অনুমোদন, মনে করিয়ে দেওয়া বার্তা ও আপডেট দেখা যায়। লাল বিন্দু থাকলে বুঝবেন কোনো বিষয়ে আপনার কাজ বাকি আছে।',
          'আপনার অ্যাকাউন্ট: পাসওয়ার্ড বদলাতে, ভূমিকা পরিবর্তন করতে (যদি আপনার admin/asset access থাকে) বা সাইন আউট করতে ওপরের ডান দিকে নিজের নাম/ছবিতে চাপুন।',
          'Quick Actions: নিচের ডান দিকে ভাসমান গোল বোতাম থেকে সাধারণ কাজগুলো এক চাপে করা যায়।',
          'ভাষা: এই গাইড নিজের পছন্দের ভাষায় পড়তে ওপরে থাকা ভাষা বাছাইয়ের অপশন ব্যবহার করুন (শিগগির আরও ভাষা যোগ হবে)।',
        ],
      },
      {
        heading: 'অ্যাপের মতো ইনস্টল করুন (পরামর্শ দেওয়া হচ্ছে)',
        items: [
          'পোর্টালটি আপনার ফোনে অ্যাপের মতো (PWA) চলে—কোনো app store দরকার নেই।',
          'Android (Chrome)-এ: ⋮ মেনুতে চাপুন → "Add to Home screen" / "Install app" বেছে নিন।',
          'iPhone (Safari)-এ: Share আইকনে চাপুন → "Add to Home Screen" বেছে নিন।',
          'পুরো স্ক্রিনে দ্রুত ব্যবহার করতে ফোনের home screen থেকে এটি খুলুন।',
        ],
      },
      {
        text: 'পাসওয়ার্ড ভুলে গেছেন? লগইন স্ক্রিনে "Forgot password?" চাপুন এবং কাজের ইমেইল দিন—নতুন পাসওয়ার্ড সেট করার লিংক ইমেইলে পাবেন।',
      },
      {
        text: 'সর্বশেষ তথ্য পেতে যেকোনো পৃষ্ঠায় ওপর থেকে নিচে টেনে refresh করুন।',
      },
    ],
  },

  dashboard: {
    title: 'আপনার Dashboard',
    summary: 'আপনার মূল স্ক্রিন—গুরুত্বপূর্ণ তথ্যের সংক্ষিপ্ত চিত্র এবং নিয়মিত কাজের শর্টকাট।',
    routeLabel: 'Dashboard-এ যান',
    blocks: [
      {
        text: 'Dashboard আপনার মূল স্ক্রিন। সাইন ইন করলে এটি খুলবে এবং ওপরের বাঁ দিকে কোম্পানির লোগো চাপলে যেকোনো সময় এখানে ফিরতে পারবেন। এখানে সংক্ষিপ্ত তথ্য ও শর্টকাট থাকে—আপনার ভূমিকা অনুযায়ী কার্ডগুলো দেখা যায়।',
      },
      {
        heading: 'সবাই যা দেখতে পান',
        items: [
          'ওপরে আপনার নামসহ শুভেচ্ছা বার্তা।',
          'Recent Leave Applications: আপনার সর্বশেষ ছুটির আবেদন ও অবস্থা (Pending, Approved ইত্যাদি)। বিস্তারিত দেখতে চোখের আইকন বা Leave Management খুলতে "View all" চাপুন।',
          'Leave Balances: প্রতিটি ছুটির ধরনের কার্ডে পাওয়া দিন, ব্যবহৃত দিন ও মোট প্রাপ্যতা দেখা যায়। পুরো তালিকার জন্য "View all" চাপুন।',
        ],
      },
      {
        text: 'Quick Actions: যেকোনো স্ক্রিনের নিচের ডান দিকে ভাসমান গোল বোতামে চাপলে Clock In/Out, Apply for Leave এবং Submit a Petty Cash Claim এক চাপেই করা যায়। Staff ও Director-রা ডিজিটাল নামের কার্ড শেয়ার করতে "My Name Card"-ও পান।',
      },
      {
        text: 'My Approvals: আপনার সিদ্ধান্তের অপেক্ষায় থাকা ছুটির আবেদন এই কার্ডে দেখা যায় এবং Dashboard-এর সংখ্যা-চিহ্নে মোট কতটি আছে তা দেখায়। অনুমোদন বা প্রত্যাখ্যানের নিয়ম জানতে "Reporting Officer-দের জন্য: ছুটি অনুমোদন" অংশ দেখুন।',
      },
      {
        heading: 'Team Alerts (Reporting Officer ও HOD)',
        items: [
          'Team Alerts আপনার দলের উপস্থিতির ব্যতিক্রম দেখায়—যেমন কোনো কর্মী Clock In করেছেন কিন্তু Clock Out করেননি।',
          'পর্যালোচনা ও সমাধানের জন্য alert-এ চাপুন (যেমন কর্মীর হয়ে Clock Out-এর সময় নিশ্চিত করা)।',
        ],
      },
      {
        text: 'Nightwork এবং Worker Trade Transfer কার্ড আপনার ক্ষেত্রে প্রযোজ্য হলে এখানে দেখা যাবে—যেমন সক্রিয় nightwork assignment, recovery day (বিশ্রামের দিন), অথবা আপনার স্বীকৃতির অপেক্ষায় trade-transfer থাকলে। খুলতে কার্ডের "View All" চাপুন। (বিস্তারিত জানতে Nightwork ও Worker Trade Transfer অংশ দেখুন।)',
      },
    ],
  },

  attendance: {
    title: 'Clock In ও Clock Out',
    summary: 'প্রতিদিন আপনার কাজের সময় ও সাইটের অবস্থান রেকর্ড করুন।',
    routeLabel: 'Attendance খুলুন',
    blocks: [
      {
        text: 'সাইডবার থেকে Attendance ("Attendance — Clock In/Out & Time Tracking") খুলুন। এখানে Singapore-এর বর্তমান সময় এবং আজকের আপনার কার্যক্রম দেখা যায়।',
      },
      {
        heading: 'যেভাবে Clock In করবেন',
        items: [
          'সবুজ "Clock In" বোতামে চাপুন।',
          'ফোন চাইলে location access অনুমতি দিন—GPS দিয়ে আপনার সাইট নিশ্চিত করা হয়।',
          '"Select Location" পপ-আপে আপনার project বেছে নিন। কাছাকাছি project (প্রায় 300m-এর মধ্যে) "Nearby" tab-এ দেখা যায়; না হলে "All Projects" বা search box ব্যবহার করুন।',
          'Project-এ একাধিক work site থাকলে "Select Work Site" পপ-আপে আপনার site বেছে নিন। (একটি site থাকলে সেটি নিজে থেকেই বেছে নেওয়া হবে।)',
          'আপনার Clock In সম্পন্ন—বোতামটি লাল ("Clock Out") হবে এবং শুরুর সময়সহ "Active since" দেখা যাবে।',
        ],
      },
      {
        heading: 'যেভাবে Clock Out করবেন',
        items: [
          'লাল "Clock Out" বোতামে চাপুন। নতুন GPS location নিজে থেকেই নেওয়া হবে।',
          'চাওয়া হলে আজ কী কাজ করেছেন তা অন্তত 10 অক্ষরে Work Description-এ লিখে "Submit & Clock Out" চাপুন।',
          'কর্মীদের overtime সম্পর্কে জিজ্ঞেস করা হতে পারে: "Yes"/"No" দিন, কাজ শেষের সময় বেছে নিয়ে নিশ্চিত করুন। এর মাধ্যমেই OT দাবি করা যায়।',
          '"Clocked out successfully" বার্তা দেখতে পাবেন।',
        ],
      },
      {
        heading: 'আপনার কার্যক্রম ও সারসংক্ষেপ',
        items: [
          'Activity list: প্রতিটি Clock In/Clock Out-এর সময়কাল, work site, project code এবং আপনার লেখা note দেখা যায়।',
          'সময়কাল বদলানো: funnel আইকনে চেপে Today, This Week, This Month ও Last Month বেছে নিন—activity list ও Summary একসঙ্গে বদলাবে।',
          'Summary panel: বেছে নেওয়া সময়ে আপনার কাজের দিন ও কাজের ঘণ্টা দেখায় (নির্ধারিত lunch/dinner break কাজের ঘণ্টা থেকে বাদ যায়)।',
          'আজ Nightwork shift বা Recovery day (কাজ করতে হবে না) হলে banner-এ জানানো হবে।',
        ],
      },
      {
        text: 'এখানে আপনার overtime-ও দেখা যাবে—MOM-এর মাসিক 72 ঘণ্টার সীমায় কতটুকু গণনা হচ্ছে তা-সহ (মাস চললে "Live", শেষ হলে "Finalized")। Summary-এর নিচে মাসিক overtime calendar-ও থাকবে।',
      },
      {
        text: 'Clock In করতে location আবশ্যক। "Location permission denied" দেখলে browser/phone settings-এ পোর্টালের location access চালু করে আবার চেষ্টা করুন।',
      },
    ],
  },

  'leave-apply': {
    title: 'ছুটির আবেদন',
    summary: 'ছুটির আবেদন করুন, কাগজপত্র যুক্ত করুন এবং অনুমোদনের অবস্থা দেখুন।',
    routeLabel: 'Leave খুলুন',
    blocks: [
      {
        heading: 'ছুটির আবেদন করুন',
        items: [
          'সাইডবার থেকে "Leave Management" খুলুন।',
          'ওপরে "Apply for Leave" অথবা নির্দিষ্ট balance card-এর "Apply" চাপুন।',
          'তালিকা থেকে ছুটির ধরন বেছে নিন (যেগুলোর জন্য আপনি যোগ্য, শুধু সেগুলোই দেখা যাবে)।',
          'শুরু ও শেষের তারিখ বেছে নিন। অর্ধদিবসের জন্য তারিখের AM/PM toggle ব্যবহার করুন।',
          'ছুটির ধরন অনুযায়ী প্রয়োজনীয় তথ্য (যেমন কারণ) পূরণ করে "Submit Application" চাপুন।',
          '"Leave application submitted successfully!" দেখা যাবে এবং আবেদনটি Pending অবস্থায় তালিকায় আসবে।',
        ],
      },
      {
        heading: 'কিছু ছুটির জন্য যেসব কাগজপত্র দরকার',
        items: [
          'Marriage Leave: Profile → Documents → Family Documents-এ Marriage Certificate upload করে HR যাচাই করার পরই এটি পাওয়া যাবে। আগেই upload করুন।',
          'Maternity / Paternity Leave: শিশুর Birth Certificate upload করে HR যাচাই করলে পাওয়া যাবে (Paternity-এর জন্য Marriage Certificate-ও দরকার)। Profile → Documents → Family Documents-এ upload করুন।',
          'Sick / Hospitalisation Leave: আবেদনের সময় Medical Certificate (ছবি বা PDF) upload করুন। System নিজে পড়ে—ছবি পরিষ্কার রাখুন।',
          'Compassionate Leave: Death Certificate upload করুন (আপনার হাতে 30 দিন সময় আছে; HR যাচাই করবে)।',
          'Home Leave / Urgent Leave (কর্মী): অনুমোদনের পর flight ticket upload করুন, যাতে HR যাচাই করতে পারে।',
        ],
      },
      {
        text: 'Marriage, Maternity ও Paternity Leave কাগজপত্রের ওপর নির্ভরশীল। সংশ্লিষ্ট certificate profile-এ upload করে HR যাচাই না করা পর্যন্ত ছুটির তালিকায় এগুলো দেখা যাবে না। প্রয়োজনের সময় যেন ছুটি প্রস্তুত থাকে, তাই আগেই upload করুন।',
      },
      {
        heading: 'আপনার balance বুঝুন',
        items: [
          'প্রতিটি ছুটির ধরনের "Leave Balances" card-এ পাওয়া দিন, ব্যবহৃত দিন ও মোট প্রাপ্যতা দেখা যায়।',
          'Annual Leave পেতে অন্তত 3 মাস চাকরি করতে হয়; তার আগে (বা balance শেষ হলে) আবেদন Unpaid Leave হিসেবে জমা হবে—প্রযোজ্য হলে পৃষ্ঠায় জানানো হবে।',
          'Annual Leave আবেদন করলে Off in Lieu (OIL) নিজে থেকে আগে ব্যবহার হয় (সবচেয়ে পুরোনোটি আগে)। Card-এ প্রতিটি OIL credit-এর expiry date থাকে—মেয়াদ শেষ হওয়ার আগে ব্যবহার করুন, কারণ expired OIL ফেরত দাবি করা যায় না।',
          'কিছু ছুটি (যেমন Marriage বা Compassionate Leave) যোগ্য হওয়ার পর বা প্রথমবার ব্যবহার করলে দেখা যায়।',
        ],
      },
      {
        text: 'Annual Leave কীভাবে জমে: কাজ করার সঙ্গে সঙ্গে Annual Leave অর্জিত হয়—1 January-এ সব একসঙ্গে দেওয়া হয় না। চাকরির প্রতিটি পূর্ণ মাসের জন্য বার্ষিক প্রাপ্যতার একটি অংশ আপনার মাসিক চাকরি-পূর্তির তারিখের ("monthsary") কাছাকাছি যোগ হয়। তাই balance প্রতি মাসে বাড়ে। চাকরির এক বছর পূর্ণ হলে আপনি পুরো বার্ষিক প্রাপ্যতা পান, আর চাকরির বছর বাড়ার সঙ্গে অতিরিক্ত দিনও বাড়ে। তাই শুরুর দিকে balance বার্ষিক মোট সংখ্যার চেয়ে কম দেখাতে পারে—প্রতি মাস পূর্ণ হলে তা বাড়তে থাকবে।',
      },
      {
        text: 'Annual Leave কীভাবে নিজে থেকে ভাগ হয়: আবেদন করলে system নির্দিষ্ট ক্রমে balance ব্যবহার করে—প্রথমে আপনার অর্জিত Off in Lieu (OIL; যেটির মেয়াদ আগে শেষ হবে সেটি আগে), তারপর Annual Leave balance, এবং এগুলো শেষ হলে বাকি অংশ Unpaid Leave হয়। জমা দেওয়ার আগে form-এ ভাগটি দেখায় (যেমন "2 OIL + 2 AL + 1 UL"), তাই কত দিন unpaid হবে—যদি হয়—তা আগে থেকেই জানতে পারবেন।',
      },
      {
        heading: 'নির্দিষ্ট ছুটির ধরন কখন ব্যবহার করবেন',
        items: [
          'External Activity: কোম্পানির কাজে এমন কোথাও গেলে এটি ব্যবহার করুন যেখানে project location-এ Clock In/Out করা যায় না—যেমন seminar, conference বা company business trip। Project বা site-এ কাজ করলে স্বাভাবিকভাবে সেখানেই Clock In ও Clock Out করুন। Activity type বেছে location ও সংক্ষিপ্ত business justification লিখুন।',
          'On Course: কোম্পানি অনুমোদিত training বা course-এ গেলে আবেদন করুন—course/training-এর নাম ও location লিখুন।',
          'Claim: Off in Lieu: rest day, Sunday বা public holiday-তে অনুমোদিত কাজের জন্য OIL দাবি করুন—কাজের তারিখ থেকে 30 দিনের মধ্যে জমা দিন (আজকের জন্য দাবি করা যায় না)। মনে রাখুন: OT পাওয়ার যোগ্য workmen (কর্মী) কর্মদিবসে নিয়মিত সময়ের পর কাজের জন্য নগদ overtime পান, তাই একই কাজের জন্য OIL-ও দাবি করতে পারবেন না। কর্মদিবসে after-hours OIL শুধু non-OT staff-এর জন্য।',
        ],
      },
      {
        heading: 'পারিবারিক ছুটি: Maternity, Paternity, Shared Parental ও Childcare',
        items: [
          'Shared Parental Leave (SPL)-এর আগে Maternity / Paternity Leave ব্যবহার হয়। নিজের আইনগত parental leave পুরো শেষ হলে তবেই SPL চালু ও তালিকায় দেখা যায়—মায়ের জন্য Maternity Leave, বাবার জন্য Paternity Leave। তার আগে SPL আবেদন করলে system আটকে দেবে এবং আগে কোন ছুটি নিতে হবে জানাবে।',
          'এই parental leave শিশুর জন্মতারিখের সঙ্গে যুক্ত (calendar year-এর সঙ্গে নয়) এবং মেয়াদ শেষ হওয়া পর্যন্ত (জন্মের 12 মাসের মধ্যে) বৈধ থাকে। তাই balance পরের বছরেও expiry পর্যন্ত নেওয়া যায়।',
          'Childcare Leave (CCL) প্রতি calendar year-এর প্রাপ্যতা: প্রতি বছর 1 January-এ নতুন হয়। অব্যবহৃত CCL পরের বছরে যায় না, তাই যে বছরের ছুটি সে বছরের মধ্যেই ব্যবহারের পরিকল্পনা করুন।',
        ],
      },
      {
        text: 'Home Leave ও Annual Leave-এর পার্থক্য: Singapore ছেড়ে নিজের দেশে ফিরলে Home Leave নিন। Singapore-এ থেকে ছুটি কাটালে (domestic) Annual Leave নিন। ভ্রমণের পরিকল্পনার সঙ্গে যেটি মেলে সেটি বেছে নিন।',
      },
      {
        text: 'একটি Home Leave ভ্রমণ সর্বোচ্চ 30 calendar day (অথবা এ বছরে আপনার যত দিন বাকি আছে) হতে পারে। শুরু তারিখ বেছে নিলে form সর্বশেষ ফেরার তারিখ দেখাবে। শুরু ও ফেরার দিন—দুটিই গণনা হয়: 24 Oct থেকে 24 Nov মোট 32 দিন, তাই 24 Oct থেকে সর্বশেষ ফেরার তারিখ 22 Nov।',
      },
      {
        heading: 'অবস্থা দেখুন, সম্পাদনা বা বাতিল করুন',
        items: [
          'প্রতিটি আবেদনের অবস্থা দেখা যায়: Pending, Approved, Auto Approved, Rejected বা Cancelled।',
          '"View Details" দেখতে চোখের আইকনে চাপুন; অনুমোদনের অগ্রগতি ও পরবর্তী অনুমোদনকারী কে তা দেখা যাবে।',
          'Draft Edit করতে, ভবিষ্যতের Pending আবেদন Delete করতে বা Approved আবেদন Cancel করতে পারবেন (balance ফেরত আসবে)। Cancel করার সময় কারণ দেওয়া বাধ্যতামূলক।',
        ],
      },
      {
        text: 'আগে আবেদন করুন। কিছু ছুটিতে আগাম notice দরকার—Home Leave-এর জন্য 30 দিন। Urgent Leave-এ আগাম notice লাগে না (অপেক্ষা করা সম্ভব নয় এমন জরুরি ক্ষেত্রে নিন)। দেরি হয়ে গেলে form সতর্ক করবে।',
      },
    ],
  },

  'leave-extension': {
    title: 'Home Leave বা Urgent Leave বাড়ানো',
    summary: 'বিদেশে আছেন এবং আরও সময় দরকার? অনুমোদিত Home বা Urgent Leave-এ দিন যোগ করুন।',
    routeLabel: 'Leave খুলুন',
    blocks: [
      {
        text: 'অনুমোদিত Home Leave বা Urgent Leave-এ আছেন এবং ফেরার আগে আরও কয়েক দিন দরকার? নতুন আবেদন না করে পোর্টালের ভেতর থেকেই extension চাইতে পারেন। শুধু Home Leave ও Urgent Leave বাড়ানো যায়।',
      },
      {
        heading: 'Extension-এর আবেদন করুন',
        items: [
          '"Leave Management" খুলে অনুমোদিত Home Leave বা Urgent Leave-এর চোখের আইকনে চেপে বিস্তারিত দেখুন।',
          'নিচের দিকে "Home Leave / Urgent Leave Extension" অংশে গিয়ে "Request Extension" চাপুন। (ছুটি চলাকালেই এই বোতাম দেখা যায়।)',
          'New Return Date বেছে নিন—অতিরিক্ত দিন বর্তমান শেষ তারিখের পরের দিন থেকে আপনার নতুন তারিখ পর্যন্ত হবে।',
          'সংক্ষিপ্ত Reason for Extension লিখে (বাধ্যতামূলক) জমা দিন।',
          '"Extension request submitted. Awaiting approval." দেখা যাবে। আপনার মূল ছুটি যারা অনুমোদন করেছিলেন, তাদের কাছেই এটি যাবে।',
        ],
      },
      {
        heading: 'কখন আবেদন করতে পারবেন',
        items: [
          'ছুটি পুরোপুরি Approved হতে হবে—Pending বা Rejected আবেদন বাড়ানো যায় না।',
          'শুধু ছুটি চলাকালে আবেদন করা যায়: শুরু তারিখে বা তার পরে এবং বর্তমান শেষ তারিখে বা তার আগে। ছুটি শুরুর আগে বা শেষের পরে আবেদন করা যাবে না।',
          'সবসময় মূল আবেদনে extension চান, আগের কোনো extension-এ নয়।',
          'একবারে শুধু একটি extension Pending থাকতে পারে—আরেকটি চাওয়ার আগে সেটি Approved বা Rejected হওয়া পর্যন্ত অপেক্ষা করুন।',
        ],
      },
      {
        text: 'Home Leave ও Urgent Leave মিলিয়ে বছরে সর্বোচ্চ 60 calendar day (প্রতি 1 January-এ reset)। Form-এ বাকি দিন ও সর্বশেষ কোন return date নেওয়া যাবে দেখায়—সীমা ছাড়ালে আবেদন আটকে যাবে।',
      },
      {
        heading: 'অনুমোদনের পর—নতুন flight ticket upload করুন',
        items: [
          'Approved হলে extension card-এ "Upload Ticket" দেখা যাবে। খুলতে card-এ চাপুন।',
          'আপডেট করা return flight ticket upload করুন, যাতে HR ভ্রমণ যাচাই করতে পারে।',
          'HR review করলে card প্রথমে "HR Reviewing", ticket গৃহীত হলে "Activated" হবে।',
        ],
      },
      {
        heading: 'Extension-এর অবস্থা দেখুন',
        items: [
          'প্রতিটি extension আলাদা card হিসেবে extension অংশে দেখা যায়, যেখানে নতুন তারিখ ও status থাকে।',
          'Status: "Awaiting Approval" → "Upload Ticket" (approved, ticket দরকার) → "HR Reviewing" (ticket জমা) → "Activated" (ticket গৃহীত)। "Rejected" বা "Ticket Rejected" হলে আপনার ব্যবস্থা নিতে হবে।',
          'Leave list-এ এই আবেদনের পাশে "Extension" badge থাকে, তাই মূল ছুটি থেকে আলাদা বোঝা যায়।',
        ],
      },
    ],
  },

  'leave-calendar': {
    title: 'Leave Calendar',
    summary: 'আপনার বিভাগ বা কোম্পানিতে কারা ছুটিতে আছেন দেখুন।',
    routeLabel: 'Leave Calendar খুলুন',
    blocks: [
      {
        heading: 'ছুটির সময়সূচি দেখুন',
        items: [
          'সাইডবার থেকে "Leave Calendar" খুলুন।',
          'ওপরের toggle দিয়ে "Department" ও "Company" view বদলান।',
          'Month arrow দিয়ে মাস বদলান; বর্তমান মাসে ফিরতে "Today" চাপুন।',
          'কোনো তারিখে চাপলে সেদিন কারা ছুটিতে আছেন তা department অনুযায়ী দেখা যাবে।',
        ],
      },
      {
        heading: 'Search ও filter',
        items: [
          'নাম বা Staff ID দিয়ে কাউকে খুঁজতে search box ব্যবহার করুন।',
          'নির্দিষ্ট সহকর্মী বেছে নিতে filter (funnel) বোতাম ব্যবহার করুন—পরেরবারের জন্য আপনার নির্বাচন মনে রাখা হবে।',
          'Calendar-এ শুধু Approved leave দেখা যায়। Public holiday ছায়াযুক্ত ও label করা থাকে।',
        ],
      },
      {
        text: 'গোপনীয়তা রক্ষার জন্য ছুটির সঠিক কারণের বদলে সাধারণ label (যেমন "Out of Office", "Unavailable") দেখানো হয়। নিচের legend-এ রংগুলোর অর্থ আছে।',
      },
    ],
  },

  profile: {
    title: 'আমার Profile',
    summary: 'যোগাযোগের তথ্য, জরুরি যোগাযোগ ও কাগজপত্র হালনাগাদ রাখুন।',
    routeLabel: 'My Profile খুলুন',
    blocks: [
      {
        heading: 'Profile-এ যা আছে',
        items: [
          'ওপরের tab: Personal, Employment, Compensation, Professional, Legal & Compliance এবং Documents (প্রযোজ্য হলে Name Card / Skills Upgrading-ও থাকবে)।',
          'সংবেদনশীল তথ্যের (phone, NRIC, salary, bank) পাশে চোখের আইকনে চেপে দেখান বা লুকান।',
        ],
      },
      {
        heading: 'যোগাযোগের তথ্য বদলান',
        items: [
          '"Personal" tab-এ "Edit Profile" চাপুন।',
          'নিজের phone, personal email, বাসার address এবং unit/postal code বদলাতে পারবেন।',
          'Address edit করার সময় postal code লিখে "Find Address" চাপলে বাকি অংশ নিজে থেকে পূরণ হবে।',
          'রাখতে "Save Changes" অথবা বাদ দিতে "Cancel" চাপুন।',
        ],
      },
      {
        heading: 'জরুরি যোগাযোগ যোগ করুন',
        items: [
          '"Personal" tab-এ "Emergency Contacts" খুঁজে "Add Contact" চাপুন।',
          'পুরো নাম, সম্পর্ক এবং অন্তত একটি phone number লিখুন (international format ব্যবহার করুন, যেমন +65 9000 0000)।',
          'রাখতে "Add Contact" চাপুন। যেকোনো সময় contact edit বা delete করতে পারবেন।',
        ],
      },
      {
        heading: 'কাগজপত্র upload করুন (Documents tab)',
        items: [
          '"Documents" tab, তারপর "Document Uploads" sub-tab খুলুন।',
          'সঠিক category খুঁজে file-টি drop zone-এ টেনে দিন অথবা phone/computer থেকে নিতে "browse" চাপুন।',
          'প্রতি file PDF বা image (JPG/PNG) এবং সর্বোচ্চ 5MB হতে পারে। ID card-এর পরিষ্কার নমুনা ছবি দেখতে "Sample" চাপুন।',
          'System file scan (OCR) করলে পড়া শেষ হওয়া পর্যন্ত অপেক্ষা করুন—অন্য পৃষ্ঠায় যাবেন না। তারপর verification pop-up-এ পাওয়া তথ্য যাচাই করে HR review-এর জন্য জমা দিন।',
          'প্রতিটি upload-এর status: Processing, Pending HR / Pending Review, Verified বা Rejected।',
        ],
      },
      {
        heading: 'কোন drop zone ব্যবহার করবেন',
        items: [
          'Identity Documents — ID Card (Front), ID Card (Back), Passport, Driving Licence।',
          'Banking Documents — bank statement/letter; এর মাধ্যমেই bank account হালনাগাদ হয় (সরাসরি টাইপ করা হয় না)।',
          'Education Certificates & Professional Certificates — শিক্ষাগত যোগ্যতা ও professional certificate (এগুলো Professional tab-এ record যোগ করে)।',
          'Family Documents — Birth Certificate, Marriage Certificate এবং Compassionate Leave-এর Death Certificate (এগুলো upload করলে Childcare, Maternity, Paternity বা Marriage Leave পাওয়া যেতে পারে)।',
          'Medical Documents এবং Other Documents — HR চেয়েছে এমন অন্য কাগজপত্র।',
        ],
      },
      {
        text: 'নির্ভুলতার জন্য কিছু তথ্য (নাম, পরিচয় নম্বর, salary, bank account) HR রক্ষণাবেক্ষণ করে। Bank account বদলাতে সরাসরি edit না করে Documents → Banking Documents-এ bank document upload করুন।',
      },
      {
        heading: 'Skills Upgrading (কর্মী)',
        items: [
          'কর্মীদের Profile-এ "Skills Upgrading" tab-এ construction classification দেখা যায়: skill level, মোট construction experience, মাসিক foreign-worker levy এবং source country।',
          '"Current BCA Registrations"-এ trade registration (যেমন CoreTrade, Multi-skilling) ও expiry date থাকে এবং শিগগির মেয়াদ শেষ হলে বা শেষ হয়ে গেলে সতর্ক করে।',
          '"Upgrade Pathways" আপনি কোন পথে যোগ্য হতে পারেন তা দেখায় এবং প্রতিটি শর্ত (experience, salary, skills assessment) যাচাই করে, ফলে upgrade করতে আর কী দরকার বুঝতে পারবেন।',
          'এই tab শুধু দেখার জন্য—কোনো তথ্য ভুল মনে হলে বা upgrade করতে চাইলে HR-এর সঙ্গে কথা বলুন।',
        ],
      },
      {
        heading: 'Digital Name Card (staff ও director)',
        items: [
          '"Legal & Compliance" tab-এ গিয়ে "Digital Name Card Consent" খুঁজুন।',
          'যে business field শেয়ার করতে চান (যেমন designation, department, work email/phone) চালু করুন। আপনার পুরো নাম সবসময় থাকবে।',
          'বাছাই করা field unique link ও QR code দিয়ে সবার জন্য দেখা যাবে—এই acknowledgement-এ tick দিয়ে "Activate Name Card" চাপুন।',
          'এরপর "Name Card" tab দেখা যাবে। সেখান থেকে QR code share, link copy, card pause বা link regenerate করতে পারবেন।',
        ],
      },
      {
        text: 'Digital name card সম্পূর্ণ আপনার ইচ্ছাধীন এবং consent দরকার—activate না করা পর্যন্ত কিছুই শেয়ার হয় না। ব্যক্তিগত তথ্য (NRIC/FIN, passport, বাসার address, personal email, salary ইত্যাদি) কখনো এতে থাকে না এবং যেকোনো সময় consent প্রত্যাহার করতে পারবেন।',
      },
    ],
  },

  'staff-directory': {
    title: 'Staff Directory',
    summary: 'সহকর্মীদের খুঁজুন এবং কোম্পানির কাঠামো দেখুন।',
    routeLabel: 'Staff Directory খুলুন',
    blocks: [
      {
        heading: 'সহকর্মী খুঁজুন',
        items: [
          'সাইডবার থেকে "Staff Directory" খুলুন।',
          'নাম, Staff ID, work email বা designation দিয়ে search করুন।',
          'Department অনুযায়ী কমিয়ে আনতে filter বোতাম ব্যবহার করুন।',
          'কাউকে চাপলে তার work email ও phone-সহ card খুলবে (email বা call করতে চাপুন)।',
        ],
      },
      {
        heading: 'দেখার ধরন',
        items: [
          'Grid View: সহকর্মীদের card (default)।',
          'List View: Reporting Officer-সহ ছোট table।',
          'Organization Chart: reporting hierarchy দেখুন; PDF হিসেবেও download করতে পারবেন।',
        ],
      },
      {
        text: 'শুধু কাজের যোগাযোগের তথ্য দেখানো হয়। Personal phone, বাসার address ও পরিচয় নম্বর সহকর্মীরা কখনো দেখতে পান না।',
      },
    ],
  },

  'my-assets': {
    title: 'আমার Assets',
    summary: 'আপনাকে দেওয়া কোম্পানির সরঞ্জাম দেখুন এবং transfer/return সম্পন্ন করুন।',
    routeLabel: 'My Assets খুলুন',
    blocks: [
      {
        heading: 'যা দেখতে পাবেন',
        items: [
          '"My Assets" tab: বর্তমানে আপনাকে দেওয়া সব asset category অনুযায়ী (IT, Access, Fleet ইত্যাদি)।',
          '"Transactions" tab: আপনার কাজের অপেক্ষায় থাকা বিষয় এবং আগের asset history। কতটি অপেক্ষায় আছে তা badge-এ দেখা যায়।',
        ],
      },
      {
        heading: 'আপনাকে দেওয়া সরঞ্জাম গ্রহণের স্বীকৃতি দিন',
        items: [
          '"Transactions" tab-এ যান।',
          '"Needs your action"-এর নিচে item খুঁজে "Acknowledge receipt" চাপুন।',
          'দায়িত্বের declaration পড়ে tick দিন, তারপর confirm করুন। Asset এখন "My Assets"-এ দেখা যাবে।',
        ],
      },
      {
        heading: 'সহকর্মীর transfer গ্রহণ করুন',
        items: [
          '"Transactions"-এ incoming transfer খুলে "Accept" চাপুন।',
          'অবস্থা বেছে নিন (New / Good / Fair / Poor / Faulty)।',
          'Item-এর অন্তত একটি ছবি যোগ করে "Accept Transfer" চাপুন।',
        ],
      },
      {
        heading: 'Asset ফেরত দিন',
        items: [
          '"My Assets"-এ item খুলে "Return to Inventory" চাপুন।',
          'কারণ বেছে (দরকার হলে note যোগ করে) "Request Return" চাপুন।',
          'Asset custodian সরাসরি asset ফেরত পাওয়া নিশ্চিত করলে কাজটি সম্পন্ন হবে।',
        ],
      },
      {
        text: 'Asset-এর স্বীকৃতি বা গ্রহণ করলে system আপনার record হিসেবে signed acknowledgement letter (PDF) তৈরি করে। যেকোনো সময় asset খুলে "View acknowledgement letter" চাপলে দেখতে বা download করতে পারবেন।',
      },
      {
        text: 'Transfer ও return 7 দিনের মধ্যে শেষ না হলে মেয়াদ শেষ হয়। "(Expiring soon!)" লেখা item-এর 24 ঘণ্টার কম সময় বাকি।',
      },
    ],
  },

  payslips: {
    title: 'Payslip',
    summary: 'আপনার বিস্তারিত salary statement দেখুন ও download করুন।',
    routeLabel: 'Payslips খুলুন',
    blocks: [
      {
        heading: 'Payslip দেখুন ও download করুন',
        items: [
          'সাইডবার থেকে "Payslips" খুলুন।',
          '"Choose a month"-এর নিচে year ও month বেছে নিন (যে মাসে payslip আছে তা আলাদা করে দেখানো হয়)।',
          'সম্পূর্ণ বিস্তারিত (earnings, deductions, net pay) দেখতে "Preview" চাপুন।',
          'Download করতে "PDF" চাপুন। Preset (Last 3 / 6 / 12 months) দিয়ে কয়েক মাস এক PDF-এ নিতে পারবেন।',
        ],
      },
      {
        heading: 'জেনে রাখা ভালো',
        items: [
          'অন্য কেউ screen দেখতে পারে এমন সময় amount লুকাতে বা দেখাতে চোখের আইকন ব্যবহার করুন।',
          'মাসের payroll Approved ও Released হওয়ার পরই payslip দেখা যায়—প্রস্তুত হলে notification পাবেন।',
          'Yearly totals card-এ বছরের net pay, gross, deductions ও overtime দেখা যায়।',
        ],
      },
      {
        text: 'Digital payslip portal বর্তমানে কর্মীদের জন্য চালু। Staff হিসেবে "Coming Soon" দেখলে বুঝবেন আপনার online payslip প্রস্তুত করা হচ্ছে।',
      },
    ],
  },

  'petty-cash': {
    title: 'Petty Cash Claim',
    summary: 'খরচের claim জমা দিন এবং অবস্থা দেখুন।',
    routeLabel: 'Petty Cash খুলুন',
    blocks: [
      {
        text: 'Petty Cash আলাদা application হিসেবে চলে। সাইডবারে "Petty Cash Claims" চাপলে single sign-on দিয়ে নিজে থেকে sign in হয়ে Petty Cash app খুলবে; সেখানে claim জমা ও track করতে পারবেন। নিজে থেকে না খুললে screen-এর "Open Petty Cash" বোতাম চাপুন।',
      },
      {
        text: 'Dental claim (Employee Handbook Clause 8) শুধু confirmed staff-এর জন্য। Probation চলাকালে অন্য petty cash claim জমা দিতে পারবেন; confirmation-এর পর dental reimbursement চালু হবে (বছরে সর্বোচ্চ S$150)।',
      },
    ],
  },

  'ro-approvals': {
    title: 'Reporting Officer-দের জন্য: ছুটি অনুমোদন',
    summary: 'আপনার দলের ছুটির আবেদন দেখে অনুমোদন বা প্রত্যাখ্যান করুন।',
    routeLabel: 'Dashboard-এ যান',
    blocks: [
      {
        text: 'ছুটির approval আপনার Dashboard-এর "My Approvals"-এ হয়। আবেদন অপেক্ষায় থাকলে notification (🔔) এবং Dashboard-এ সংখ্যার badge-ও পাবেন।',
      },
      {
        heading: 'আবেদন অনুমোদন বা প্রত্যাখ্যান করুন',
        items: [
          'Dashboard খুলে "My Approvals" card খুঁজুন।',
          'আবেদনের চোখের আইকনে চেপে "Leave Application Details" খুলুন।',
          'তারিখ, কারণ এবং "Team availability" note দেখুন (একই সময়ে অন্য কেউ ছুটিতে থাকলে এটি সতর্ক করে)।',
          'অনুমোদনের জন্য সবুজ "Approve" চাপুন। একাধিক স্তরের workflow হলে পরের approver-এর কাছে যাবে।',
          'প্রত্যাখ্যান করতে "Reject" চাপুন, কারণ লিখে (বাধ্যতামূলক) "Confirm Rejection" চাপুন।',
        ],
      },
      {
        heading: 'বিশেষ ক্ষেত্র',
        items: [
          'National Service Leave: approve/reject করতে পারবেন না—আপনি জেনেছেন তা নিশ্চিত করতে "Acknowledge" চাপুন।',
          'Sick / medical leave: HR আগে document যাচাই না করা পর্যন্ত কোনো বোতাম ছাড়া "Awaiting HR Verification" দেখতে পারেন।',
          'Notification চাপলে সরাসরি আবেদন খুলবে। আগেই ব্যবস্থা নেওয়া হলে জানানো হবে যে এটি আর Pending নেই।',
        ],
      },
      {
        text: 'দলের attendance ও wellbeing-এর বিস্তারিত দেখতে সাইডবারের "My Team" ব্যবহার করুন। মনে রাখুন: approval Dashboard-এ হয়, My Team-এ নয়।',
      },
    ],
  },

  'my-team': {
    title: 'আমার দল (Reporting Officer ও HOD)',
    summary: 'দলের attendance, leave, 72-hour OT cap ও 12-day rest-day compliance এক নজরে দেখুন।',
    routeLabel: 'My Team খুলুন',
    blocks: [
      {
        heading: 'যা দেখতে পারবেন',
        items: [
          'Overview: আপনার direct report-দের attendance ও যেসব বিষয়ে ব্যবস্থা দরকার।',
          'Trends: সময়ের সঙ্গে attendance-এর ধরন।',
          'Leave Insights: এখন কে ছুটিতে এবং দলের আসন্ন ছুটি।',
          'Individual: নির্দিষ্ট team member-এর attendance বিস্তারিত দেখুন।',
          'Big Five: career ও coaching আলোচনার জন্য personality profile খুলুন (কারণ দিতে হবে; employee access log দেখতে পাবেন)। HOD ও Deputy পুরো department দেখেন; RO শুধু direct report দেখেন।',
          'Overtime: MOM-এর মাসিক 72-hour overtime cap-এর দিকে দলের অগ্রগতি (শুধু workmen—নিচে দেখুন)।',
          'Rest Day: MOM-এর 12-day rest-day limit অনুযায়ী দলের টানা কাজের দিনের হিসাব (নিচে দেখুন)।',
          'HOD-রা "Department" tab-ও পান এবং "Direct Reports" ও পুরো department-এর মধ্যে বদলাতে পারেন।',
        ],
      },
      {
        heading: 'Rest Day বা Overtime monitoring খুলুন',
        items: [
          'সাইডবারে "My Team" চাপুন (অথবা সরাসরি /team-dashboard-এ যান)।',
          'পৃষ্ঠার ওপরে "Rest Day" বা "Overtime" tab চাপুন।',
          'সরাসরি link bookmark/share করতে পারেন: rest-day monitoring-এর জন্য /team-dashboard?tab=restday, অথবা 72-hour cap-এর জন্য /team-dashboard?tab=overtime।',
          'Table filter করতে summary card (যেমন "Action Required") চাপুন, অথবা কারও বিস্তারিত খুলতে row-এর চোখের আইকন চাপুন।',
        ],
      },
      {
        heading: 'Rest Day tab — 12 দিনের সীমা (MOM Employment Act s36)',
        items: [
          'প্রতিটি team member বিশ্রামের দিন ছাড়া টানা কত calendar day কাজ করেছেন তা দেখায়। আইনি সর্বোচ্চ 12 দিন—শুধু টানা 13তম কাজের দিনে নিয়ম ভাঙে।',
          'Status-এর রং: OK (<7 দিন), Watch (7–8), Warning (9–11), Critical (12—সর্বোচ্চ সীমা; পরের কাজের দিনের আগে rest দরকার), Violated (13+)।',
          'কেউ সীমার কাছে গেলে table-এ "Rest by …" date দেখায়—নিয়ম ঠিক রাখতে সর্বশেষ যে দিনের মধ্যে বিশ্রাম দিতে হবে।',
          'কারও detail খুললে 30 দিনের work/rest timeline, alert history এবং projection দেখা যায়: "Rest day required by" বনাম "Projected next rest day" (schedule, Approved leave ও public holiday অনুযায়ী)। তারিখ না মিললে deadline-এর আগে rest day দিতে হবে বলে system দেখাবে।',
          'Manager-দের জন্য শুধু দেখার ব্যবস্থা—এখানে alert acknowledge করা যায় না (HR admin Rest Day Monitoring page-এ করেন)। সমস্যা আগেই বুঝে দলের rest day পরিকল্পনা করতে এই tab ব্যবহার করুন।',
        ],
      },
      {
        heading: 'Overtime tab — মাসিক 72 ঘণ্টার সীমা (MOM Part IV)',
        items: [
          'আপনার দলের workmen-এর MOM 72-hour monthly cap-এ গণনা হওয়া overtime track করে। শুধু overtime-এর অতিরিক্ত অংশ গণনা হয়—rest day ও public holiday-এর regular hour বাদ থাকে।',
          'আপনার অধীনে অন্তত একজন overtime-eligible workman থাকলেই tab দেখা যায়। শুধু staff-class employee পরিচালনা করলে এটি দেখবেন না।',
          'Dropdown থেকে month বেছে নিন (default বর্তমান month)। চলতি মাসে সর্বশেষ হিসাব দরকার হলে refresh বোতাম ব্যবহার করুন।',
          'Status band: OK (<48h), At Risk (48–60h), Critical (60–72h), Exceeded (>72h)। চলতি মাসে forecast অনুযায়ী কেউ মাস শেষের আগে cap ছুঁতে পারেন মনে হলে "Watch" বা "Projected Exceed"-ও দেখা যেতে পারে।',
          'কারও daily breakdown ও 12-month trend খুলতে row-এ চাপুন। Compliance-এর জন্য "72h Cap OT" column-এর সংখ্যাই গুরুত্বপূর্ণ।',
          'Workmen নিজের cap progress Attendance page-এ দেখেন ("Clock In & Out" দেখুন)। Manager-রা পুরো দল দেখতে এই tab ব্যবহার করেন।',
        ],
      },
      {
        text: 'My Team শুধু তথ্য দেখার জন্য। Leave approve বা reject করতে Dashboard-এর "My Approvals" ব্যবহার করুন ("Reporting Officer-দের জন্য: ছুটি অনুমোদন" দেখুন)।',
      },
    ],
  },

  'self-service': {
    title: 'Self-Service Hub',
    summary: 'Request, resource, event ও আরও অনেক কিছুর এক জায়গা।',
    routeLabel: 'Self-Service খুলুন',
    blocks: [
      {
        heading: 'যা পাবেন',
        items: [
          'Requests & Approvals: Request Letters, Nightwork, Rest Day & PH Work, Course Requests এবং Overseas Travel Notice—এছাড়া ভূমিকা অনুযায়ী Worker Trade Transfer, Work Pass Decisions ও offboarding card দেখা যায়।',
          'Resources: Employee Handbook, Company Policies এবং Training Materials।',
          'Events: Meeting ও Training আয়োজন এবং attendance record।',
          'Personal Insights (স্বেচ্ছামূলক ও গোপনীয়): Big Five profile।',
          'Report a Concern: Anonymous Misconduct Reporting।',
        ],
      },
      {
        text: 'সাইডবার থেকে "Self-Service" খুলে যেকোনো card চাপুন। কিছু card (যেমন Worker Trade Transfer) আপনার ভূমিকার ক্ষেত্রে প্রযোজ্য হলেই দেখা যায়।',
      },
    ],
  },

  letters: {
    title: 'চিঠির Request',
    summary: 'Company/HR letter-এর request করুন এবং প্রস্তুত হওয়া পর্যন্ত অবস্থা দেখুন।',
    routeLabel: 'Request Letters খুলুন',
    blocks: [
      {
        heading: 'চিঠির request করুন',
        items: [
          'Self-Service → "Request Letters" খুলুন।',
          '"Create New Request"-এ Letter Type বেছে নিন: "Employment Verification" বা "Home Leave Authorization"।',
          'Employment Verification-এর জন্য Purpose বেছে নিন (যেমন Visa Application, Bank Loan, Tenancy Agreement); "Other" নিলে বিস্তারিত লিখুন।',
          '"Create Request", তারপর নিশ্চিত করতে "Submit Request" চাপুন। HR approval-এর জন্য পাঠানো হবে।',
        ],
      },
      {
        heading: 'অবস্থা দেখুন ও download করুন',
        items: [
          '"My Requests"-এ status-সহ request দেখা যায়: Pending Approval, Approved, Rejected বা Cancelled।',
          'Approved হলে preview বা download আইকন দিয়ে PDF letter নিন।',
          'Letter 60 দিন বৈধ। মেয়াদ শেষ হলে নতুন request আগে থেকে পূরণ করতে "Request a new letter" ব্যবহার করুন।',
          'Pending Approval থাকা অবস্থায় request cancel করতে পারবেন।',
        ],
      },
    ],
  },

  'shift-requests': {
    title: 'Nightwork ও Rest Day Work Request',
    summary: 'Night, rest-day বা PH work-এর কারণে পরদিন সকাল বা দিন কর্মীরা বিশ্রাম পেলে আগে approval নিন।',
    routeLabel: 'Nightwork Requests খুলুন',
    blocks: [
      {
        text: 'এই request কর্মীদের একটি দলের পক্ষে করা হয়—নিজের জন্য নয়। কর্মীরা জমা দেন না; তাদের Approved schedule "My Assignments" tab-এ দেখেন। (Rest Day & PH work পাওয়া যাবে Self-Service → "Rest Day & PH Work Request"-এ।)',
      },
      {
        heading: 'কারা জমা দেবেন',
        items: [
          'Nightwork: Trade Leader, Manager, অথবা HR অনুমতি দিয়েছে এমন ব্যক্তি। (Reporting Officer ও HOD একই সঙ্গে Trade Leader বা Manager না হলে জমা দেন না।)',
          'Rest Day / PH Work: Trade Leader, Manager এবং Reporting Officer (যার direct report আছে), অথবা HR অনুমতি দেওয়া user।',
          'Approval প্রথমে department-এর Deputy HOD, তারপর HOD দেন।',
        ],
      },
      {
        heading: 'কখন request করবেন',
        items: [
          'সিদ্ধান্তের নিয়ম: কাজের কারণে পরের সকাল বা পরের দিন বিশ্রাম/recovery (AM Only বা Full Day) হলে request করুন। এই recovery-ই একে সাধারণ overtime থেকে আলাদা করে।',
          'Nightwork: দল night shift করলে, বা স্বাভাবিক সময়ের অনেক পরে রাত পর্যন্ত কাজ করে পরের দিন বিশ্রাম নিলে ব্যবহার করুন। "Extension" (নিয়মিত দিনের কাজের পরে) বা "Standard" (দিনের shift-এর বদলে night) বেছে নিন। দেরিতে শেষ করেও পরের দিন স্বাভাবিক পূর্ণদিবস কাজ করলে এবং recovery না থাকলে Nightwork ব্যবহার করবেন না—সেটি সাধারণ OT।',
          'Rest Day / PH Work: কর্মীরা rest day বা public holiday-তে কাজ করলে সবসময় ব্যবহার করুন। Work schedule অনুযায়ী কর্মীদের 6-day week (Monday থেকে Saturday), তাই সাধারণত rest day Sunday। Shift-এর কারণে পরের সকাল/দিন বিশ্রাম দরকার হলে Full Day বা AM Only দিন; পরের দিন স্বাভাবিক working day হলে শুধু None বেছে নিন।',
          'Hours, recovery ও workers আগে approve করাতে আগেই জমা দিন। জরুরি হলে backdate করতে পারেন, তবে কারণ লিখতে হবে—payroll-এর জন্য lock হওয়া date blocked থাকবে (HR-এর সঙ্গে যোগাযোগ করুন)।',
        ],
      },
      {
        text: 'কর্মীরা সবসময় স্বাভাবিকভাবে Clock In ও Clock Out করবেন—এটি বদলায় না। Recovery হলো nightwork বা rest-day/PH work-এর পরের দিন: AM Only মানে lunch-এর পর কাজে ফেরা; Full Day মানে পুরো দিন বিশ্রাম।',
      },
      {
        heading: 'Request যেভাবে জমা দেবেন',
        items: [
          'Self-Service → "Nightwork Requests" বা "Rest Day & PH Work Request" খুলে "New Request" tab-এ যান।',
          'Step 1 — Project & Description: project বেছে কাজের বর্ণনা লিখুন।',
          'Step 2 — Dates & Times: date, start/end time এবং recovery day (Full Day, AM Only, অথবা rest day work-এর জন্য None) বেছে নিন।',
          'Step 3 — Personnel: কর্মীদের (নাম বা Staff ID দিয়ে search) এবং safety personnel যোগ করুন।',
          'Step 4 — Review & Submit: summary যাচাই করে "Submit for Approval" চাপুন।',
          '"My Requests"-এ progress দেখুন—Pending Dy HOD → Pending HOD → Approved দেখা যাবে।',
        ],
      },
      {
        text: 'Rest day work-এ MOM-এর টানা 12 working day সীমা যাচাই হয়। কোনো কর্মী সীমা ছাড়ালে এগিয়ে যাওয়ার যুক্তি হিসেবে override reason দিতে হবে।',
      },
    ],
  },

  'trade-transfer': {
    title: 'Worker Trade Transfer',
    summary: 'সংশ্লিষ্ট সবার acknowledgement নিয়ে কর্মীকে আপনার নেতৃত্বের trade-এ আনুন।',
    routeLabel: 'Worker Trade Transfer খুলুন',
    blocks: [
      {
        text: 'একজন Trade Leader নিজের নেতৃত্বের trade-এ কর্মী আনতে transfer request করেন। এরপর প্রতিটি কর্মীর জন্য বর্তমান Trade Leader, কর্মী নিজে এবং HOD একে একে acknowledgement দেন। HR শুধু দেখতে পারে, approval chain-এর অংশ নয়।',
      },
      {
        heading: 'কে এবং কখন',
        items: [
          'কে request করবেন: যে Trade Leader কর্মী গ্রহণ করবেন (incoming leader)। HR admin শুধু দেখার জন্য "All Requests" view পান।',
          'কে acknowledge করবেন: কর্মীর বর্তমান Trade Leader, তারপর কর্মী, তারপর HOD—এই ক্রমে।',
          'কখন: এক বা একাধিক কর্মীকে বর্তমান trade থেকে আপনার নেতৃত্বের trade-এ নিতে (যেমন staffing বা project-এর প্রয়োজনে)।',
        ],
      },
      {
        heading: 'Transfer request যেভাবে করবেন',
        items: [
          'Self-Service → "Worker Trade Transfer" → "Request Transfer" tab খুলুন।',
          'যে trade-এ transfer হবে সেটি (একাধিক trade-এর leader হলে) এবং effective date (আজ বা পরের তারিখ) বেছে নিন।',
          'কর্মীদের (নাম, Staff ID বা trade দিয়ে search) যোগ করে কারণ লিখুন।',
          '"Submit Request" চাপুন। "My Requests"-এ প্রতিটি কর্মীর অবস্থা দেখুন—চলমান থাকলে "Cancel Request" করতে পারবেন।',
        ],
      },
      {
        heading: 'আপনাকে acknowledge করতে বলা হলে',
        items: [
          'Notification, Dashboard card বা "My Inbox" tab থেকে request খুলে "Review" চাপুন।',
          'কর্মী: বিষয়টি জেনেছেন নিশ্চিত করতে "Accept", transfer থামাতে "Decline" চাপুন (decline-এর কারণ বাধ্যতামূলক)।',
          'বর্তমান Trade Leader / HOD: "Approve" বা "Reject" চাপুন (reject-এর কারণ বাধ্যতামূলক)।',
          'সিদ্ধান্ত record করতে "Confirm" চাপুন।',
        ],
      },
      {
        text: 'প্রতিটি কর্মী আলাদাভাবে পরিচালিত হয়—একজন Rejected হলেও batch-এর বাকিদের কাজ চলবে। তিনজনই acknowledge করলে trade change নির্ধারিত হবে এবং effective date-এ কার্যকর হবে।',
      },
    ],
  },

  'passport-return': {
    title: 'Passport ফেরত',
    summary: 'HR-এর কাছে আগে রাখা passport ফেরত দিন এবং প্রত্যেক কর্মীর প্রাপ্তি record করুন।',
    routeLabel: 'Passport Return খুলুন',
    blocks: [
      {
        heading: 'এই campaign যা করে',
        items: [
          'HR যাদের passport ইতিমধ্যে তাদের কাছে আছে বলে নিশ্চিত করেছে, তারা ছাড়া সব active worker-এর passport HR-এর কাছে আছে। তাদের passport আর physically ফেরত দেওয়া হবে না। Malaysian WP holder-রা এই campaign-এ নেই—তাদের passport কখনো রাখা হয়নি এবং acknowledge করতে হবে না।',
          'HR-এর কাছে থাকা passport স্থায়ীভাবে কর্মীকে ফেরত দেওয়া হবে; কোম্পানির হেফাজতে আর ফেরত নেওয়া যাবে না।',
          'ছুটিতে থাকা কর্মীরা ফিরে এসে policy acknowledge করবেন। যারা আগে passport তুলে নিয়েছেন, তারা এখন acknowledge করবেন—দ্বিতীয়বার হাতে passport দেওয়ার প্রয়োজন নেই।',
          'কর্মী terms sign বা acknowledge করেছেন কি না, তার ওপর সরাসরি passport ফেরত দেওয়া কখনো নির্ভর করবে না।',
          'Acknowledge করার পর কর্মী যেকোনো সময় Passport Return আবার খুলে record করা confirmation ও যে ভাষার version acknowledge করেছেন তা দেখতে পারবেন। অন্য ভাষায় acknowledge করলে reference-এর জন্য English-এও দেখতে পারবেন; এতে record করা ভাষা বদলাবে না।',
          'সব registered record acknowledged বা সাক্ষীসহ exception দিয়ে resolved হলে campaign নিজে থেকে বন্ধ হবে।',
        ],
      },
      {
        heading: 'কর্মীদের জন্য (passport HR-এর কাছে থাকলে)',
        items: [
          'আপনার original passport প্রস্তুত—HR-এর এমন notification-এর জন্য অপেক্ষা করুন।',
          'Portal-এ কিছু confirm করার আগে original passport সংগ্রহ করে পরীক্ষা করুন।',
          'Passport Return খুলে ভাষা বেছে passport রাখা ও বিদেশ ভ্রমণের দায়িত্ব পড়ুন।',
          'Passport হাতে পাওয়া confirm করে policy acknowledge করুন। কোন ভাষার version ব্যবহার করেছেন এবং timestamp audit record-এ রাখা হবে।',
          'যা confirm করেছেন তার পূর্ণ copy চাইলে PDF receipt download করুন। Screen-এর page print করবেন না।',
        ],
      },
      {
        heading: 'কর্মীদের জন্য (ইতিমধ্যে Home Leave / Urgent Leave-এ থাকলে)',
        items: [
          'ছুটিতে passport নিজের কাছে রাখুন—সংগ্রহের কোনো ধাপ নেই।',
          'ছুটি শেষে prompt পেলে Passport Return খুলুন।',
          'Original passport এখনো আপনার কাছে আছে confirm করে নিজের ভাষায় policy acknowledge করুন।',
        ],
      },
      {
        heading: 'কর্মীদের জন্য (passport আগে তুলে নিলে)',
        items: [
          'Renewal বা ব্যক্তিগত কারণে HR আগে passport দিয়ে থাকলে collection-এর কোনো ধাপ নেই।',
          'Campaign launch হওয়ার পর Passport Return খুলুন।',
          'Original passport এখনো আপনার কাছে আছে confirm করে নিজের ভাষায় policy acknowledge করুন।',
        ],
      },
      {
        heading: 'HR administrator-দের জন্য',
        items: [
          'Inventory rule নিশ্চিত করে পূর্ণ worker roster load করুন (held, on leave বা already withdrawn)।',
          'Launch-এর আগে English policy ও প্রতিটি translation-এর management/legal review নিন।',
          'Held cohort: HR passport দিতে প্রস্তুত হলে একজন বা সব held worker-কে ready হিসেবে mark করুন। প্রত্যেককে collect করার notification যাবে। Original document কর্মীর হাতে দেওয়ার পরেই handover record করুন।',
          'On-leave cohort: ছুটি শেষ হওয়া পর্যন্ত অপেক্ষা করুন; শুধু policy acknowledgement-এর জন্য record "Ack due"-তে যাবে।',
          'Already-withdrawn cohort: launch-এর পরেই policy acknowledgement দিতে হবে—physical handover নেই।',
          'Already-withdrawn worker campaign handover-এর আগে original passport HR-কে ফেরত দিলে "Passport now in the safe" ব্যবহার করুন। Record Physical return-এ যাবে। Notification পাঠাবেন না এবং passport HR-এর কাছে থাকা অবস্থায় acknowledge করতে বলবেন না।',
          'Acknowledged record-এ "View acknowledgement receipt" দিয়ে confirmation, acknowledgement-এর সময় স্থির করা passport number/expiry, exact language snapshot, timestamp এবং English reference translation দেখুন। পূর্ণ multi-page copy-এর জন্য Download PDF ব্যবহার করুন; on-screen modal print করবেন না।',
          'Handover বা leave থেকে ফেরার পর portal acknowledgement না পাওয়া গেলে দ্বিতীয় HR administrator-কে witness রেখে বিস্তারিত exception record করুন। Passport ফেরত নেবেন না।',
          'প্রতিটি action অপরিবর্তনীয় campaign timeline ও central audit log-এ রাখা হয়।',
        ],
      },
    ],
  },

  events: {
    title: 'Meeting ও Training Attendance',
    summary: 'Event আয়োজন করুন এবং পরিবর্তনশীল QR code দিয়ে attendance নিন।',
    routeLabel: 'Events খুলুন',
    blocks: [
      {
        text: 'Staff ও Director-রা event host করতে পারেন। Attendee-রা (external guest-সহ) শুধু QR code scan করবেন—বিশেষ access দরকার নেই।',
      },
      {
        heading: 'Event host করুন',
        items: [
          'Self-Service → "Meetings & Training Attendance" খুলে "New event" চাপুন।',
          'Title, type (Meeting / Training / Briefing / Other), date ও time লিখুন; চাইলে project ও location দিন।',
          '"Create event" চাপুন (Draft হিসেবে শুরু হবে), প্রস্তুত হলে "Activate & show QR" চাপুন।',
          'Phone বা TV-তে code দেখাতে "Present QR" চাপুন—নিরাপত্তার জন্য এটি নিজে থেকে বদলায়।',
          'শেষ হলে check-in বন্ধ করে attendance record নিজের email-এ পেতে "Close & email PDF" চাপুন। কেউ বাদ গেলে "Reopen for late check-ins" করতে পারবেন।',
        ],
      },
      {
        heading: 'Event-এ check in করুন',
        items: [
          'Phone camera দিয়ে QR code scan করুন।',
          'Employee: confirm করতে sign in করুন—আপনার তথ্য আগে থেকেই পূরণ থাকবে।',
          'External guest (অনুমতি থাকলে): "I\'m an external attendee" বেছে নিজের তথ্য পূরণ করুন।',
          'Screen-এ sign করে (signature বাধ্যতামূলক) "Check in" চাপুন।',
        ],
      },
      {
        text: 'QR প্রতি 20 second-এ refresh হয়, তাই পরে শেয়ার করা screenshot কাজ করবে না—সরাসরি scan করুন।',
      },
    ],
  },

  whistleblowing: {
    title: 'পরিচয় গোপন রেখে অসদাচরণ জানানো',
    summary: 'অসদাচরণ, fraud বা compliance ভঙ্গের ঘটনা গোপনে report করুন।',
    routeLabel: 'Misconduct Reporting খুলুন',
    blocks: [
      {
        text: 'আপনার report পুরোপুরি anonymous। Submission-এর কোনো তথ্য HR portal-এ রাখা হয় না—শুধু অনুমোদিত third-party assessor-এর কাছে যায়। নাম ও email দেওয়া ঐচ্ছিক; যোগাযোগ চান শুধু তখনই দিন।',
      },
      {
        heading: 'যেভাবে report করবেন',
        items: [
          'Self-Service → "Anonymous Misconduct Reporting" খুলে attention notice পড়ুন, তারপর "Done" চাপুন।',
          'Follow-up চাইলে শুধু তখনই ইচ্ছা অনুযায়ী নাম/email দিন।',
          'প্রয়োজনীয় তথ্য পূরণ করুন: কে জড়িত, violation-এর ধরন, কী ও কখন ঘটেছে, কোথায় ঘটেছে, আর কে জানেন এবং আপনি কীভাবে জেনেছেন।',
          'প্রমাণের কোনো document থাকলে attach করুন (ঐচ্ছিক)।',
          'তথ্য সত্য—এই certification-এ tick দিয়ে "Submit" চাপুন।',
        ],
      },
      {
        text: 'Confirmation screen-এ reference code (যেমন WB-YYYYMMDD-XXXXXX) পাবেন—লিখে রাখুন, কারণ portal-এ পরে report খুঁজে দেখার উপায় নেই।',
      },
    ],
  },

  'big-five': {
    title: 'Big Five Profile',
    summary: 'নিজের result-সহ স্বেচ্ছামূলক ও গোপনীয় personality assessment।',
    routeLabel: 'Big Five Profile খুলুন',
    blocks: [
      {
        text: 'Big Five সম্পূর্ণ স্বেচ্ছামূলক। আপনার উত্তর encrypted থাকে। Career আলোচনা করতে HR, HOD, Deputy HOD ও Reporting Officer আপনার ব্যক্তিগত result দেখতে পারেন—প্রতিবার কারণ দিতে হয় এবং তা access log-এ record হয়। Trade Leader ও অন্য manager ওই ভূমিকাগুলোর একটিতেও না থাকলে দেখতে পারবেন না।',
      },
      {
        heading: 'Assessment দিন',
        items: [
          'Self-Service → "Big Five Profile" খুলে "Start the assessment" চাপুন।',
          'Consent পড়ে সম্মতি দিন, তারপর "Agree & begin" চাপুন।',
          '1–5 scale-এ 120টি ছোট statement-এর উত্তর দিন (Very Inaccurate → Very Accurate)। উত্তর নিজে থেকে save হয়—যেকোনো device-এ থামিয়ে আবার শুরু করতে পারবেন।',
          'শেষ question-এ result দেখতে "Submit Big Five Profile" চাপুন।',
        ],
      },
      {
        heading: 'আপনার result ও নিয়ন্ত্রণ',
        items: [
          'পাঁচটি trait-এর score দেখুন (Openness, Conscientiousness, Extraversion, Agreeableness, Neuroticism) এবং চাইলে বিশ্বজুড়ে মানুষ বা সহকর্মীদের সঙ্গে তুলনা করুন।',
          'প্রতিটি HR access ও দেওয়া কারণ দেখতে "Who has viewed me" চাপুন।',
          'যেকোনো সময় consent প্রত্যাহার করে data স্থায়ীভাবে delete করতে পারবেন।',
          'সাধারণত প্রতি 12 মাসে একবার আবার দিতে পারবেন।',
        ],
      },
    ],
  },

  notifications: {
    title: 'Notification ও পছন্দ',
    summary: 'আপডেট থাকুন এবং কীভাবে notification পেতে চান তা বেছে নিন।',
    routeLabel: 'Notification Preferences খুলুন',
    blocks: [
      {
        heading: 'আপডেট থাকুন',
        items: [
          'সর্বশেষ notification (leave decision, reminder, asset transfer, payslip, announcement ইত্যাদি) দেখতে ওপরের ডান দিকে 🔔 ঘণ্টা চাপুন।',
          'ঘণ্টায় লাল বিন্দু মানে কিছু unread আছে।',
        ],
      },
      {
        heading: 'যেভাবে notification পাবেন তা বেছে নিন',
        items: [
          '🔔 ঘণ্টা খুলে settings (gear) আইকনে চেপে "Notification Preferences" খুলুন।',
          'Category অনুযায়ী (Leave, Attendance, Documents, Payroll, Assets, Celebrations ইত্যাদি) notification type-এর grid দেখতে পাবেন।',
          'প্রতিটি type-এর delivery channel চালু বা বন্ধ করুন: In-App, WhatsApp, Email ও Google Chat।',
          'প্রয়োগ করতে "Save Changes" চাপুন। বাদ দিতে "Cancel" ব্যবহার করুন।',
        ],
      },
      {
        heading: 'জেনে রাখা ভালো',
        items: [
          'In-App notification সবসময় চালু থাকে এবং বন্ধ করা যায় না।',
          'WhatsApp-এর জন্য profile-এ valid phone number এবং Email-এর জন্য valid email address দরকার।',
          'Lock আইকন মানে administrator channel-টি নির্ধারণ করেছেন; এখানে বদলানো যাবে না।',
          '"Disabled by policy" মানে কোম্পানি সবার জন্য ওই notification বন্ধ করেছে।',
          'Birthday Wishes: পৃষ্ঠার নিচে company-wide birthday email না নেওয়ার option বেছে নিতে পারেন।',
        ],
      },
    ],
  },

  help: {
    title: 'আরও সাহায্য দরকার?',
    summary: 'সমস্যায় পড়লে HR team-এর সঙ্গে যোগাযোগ করুন।',
    blocks: [
      {
        heading: 'HR-এর সঙ্গে যোগাযোগের আগে',
        items: [
          'Page refresh করতে ওপর থেকে নিচে টানুন—পুরোনো তথ্যের সমস্যা এতে প্রায়ই ঠিক হয়।',
          'আপনার কোনো কাজ অপেক্ষায় আছে কি না 🔔 notification-এ দেখুন।',
          'Home screen থেকে app বন্ধ করে আবার খুলে নিশ্চিত করুন যে সর্বশেষ version ব্যবহার করছেন।',
        ],
      },
      {
        text: 'এখনও সাহায্য দরকার? আপনার Staff ID ও সমস্যার সংক্ষিপ্ত বিবরণ দিয়ে HR team-কে hrm@winner-e.sg ঠিকানায় email করুন (screenshot দিলে সুবিধা হবে)।',
      },
    ],
  },
};
